import React, { useContext } from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { AuthContext } from '../context/Auth/AuthContext'
import { FuelAutoSend } from '../components/FuelAutoSend'
import {
  Alerts,
  AreaSelectorScreen,
  DetailMortality,
  DetailStates,
  DetailUVFilters,
  HomeScreen,
  LoadingScreen,
  LoginScreen,
  Mortality,
  States,
  SuccessScreen,
  UVFilter,
} from '../modules'

import { RootParams } from './types'
import { NecropsyStack } from './router/Necropsy'
import { ControlServicesStack } from './router/ControlServices'
import { LogisticsStack } from './router/Logsitic'
import { useCheckSecurity } from '../hooks/useCheckSecurity'

const Stack = createStackNavigator<RootParams>()

export const Navigation = () => {
  useCheckSecurity()

  const { user } = useContext(AuthContext)

  if (user.status === 'checking') {
    return <LoadingScreen />
  }

  const handleInitialRoute = (): keyof RootParams => {
    if (user.status === 'not-authorized') return 'Login'
    if (user.status === 'authorized' && user.areaSelected !== null) return 'HomeScreen'

    return 'Login'
  }

  return (
    <>
      {user.status === 'authorized' && <FuelAutoSend />}
      <Stack.Navigator
        initialRouteName={handleInitialRoute()}
        screenOptions={{
          headerShown: false,
        }}
      >
        {user.status === 'not-authorized' && <Stack.Screen name='Login' component={LoginScreen} />}

        {user.status === 'authorized' && (
          <>
            <Stack.Screen name='HomeScreen' component={HomeScreen} />
            <Stack.Screen name='AreaSelectorScreen' component={AreaSelectorScreen} />
            <Stack.Screen name='Alerts' component={Alerts} />
            <Stack.Screen name='SuccessScreen' component={SuccessScreen} />
            <Stack.Screen name='Mortality' component={Mortality} />

            <Stack.Screen name='DetailStates' component={DetailStates} />
            <Stack.Screen name='DetailUVFilters' component={DetailUVFilters} />
            <Stack.Screen name='DetailMortality' component={DetailMortality} />
            <Stack.Screen name='States' component={States} />
            <Stack.Screen name='UVFilter' component={UVFilter} />

            <Stack.Screen name='ControlServicesStack' component={ControlServicesStack} />

            <Stack.Screen name='NecropsyStack' component={NecropsyStack} />
            <Stack.Screen name='LogisticsStack' component={LogisticsStack} />
          </>
        )}
      </Stack.Navigator>
    </>
  )
}
